import {defineStore} from 'pinia'
import {useFormStore} from '@/stores/form'

export const useFormsStore = defineStore('forms', {
    state: () => ({
        formId: ''
    }),
    actions: {
        async createForm(d) {
            const formId = `form:${d.tableName}:${d.id}`
            
            const formStore = useFormStore(formId)
            
            await formStore.init(d)
            
            return formId
        }
    }
})